// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1iNC0","content":"styles_content__1rPqB","selectAll":"styles_selectAll__2Boim"};